import { render, staticRenderFns } from "./RegistrationRequestTrafficDetails.vue?vue&type=template&id=5a3e805a"
import script from "./RegistrationRequestTrafficDetails.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestTrafficDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports